<div>
  <canvas #canvas id="canvas" class="chart-legend"></canvas>
</div>
